import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import { PaginatedResponse } from "../../../models";
import {
  SeamConnection,
  SeamDevice,
  ConnectWebviewResponse,
  MapDeviceToRoomRequest,
  SeamDeviceCapabilities,
} from "../types/seam.types";

export class SeamService extends BaseService {
  private readonly basePath = "/api/admin/locks";

  async getConnections(
    pageNumber: number = 1,
    pageSize: number = 10,
  ): Promise<ApiResult<PaginatedResponse<SeamConnection>>> {
    return this.handleRequest<PaginatedResponse<SeamConnection>>(
      this.client.get(`${this.basePath}/connected-accounts`, {
        params: { pageNumber, pageSize },
      }),
    );
  }

  async disconnectAccount(accountId: string): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.delete(`${this.basePath}/connected-accounts/${accountId}`),
    );
  }

  async createConnectWebview(): Promise<ApiResult<ConnectWebviewResponse>> {
    return this.handleRequest<ConnectWebviewResponse>(
      this.client.post(`${this.basePath}/connect-webview`, {}),
    );
  }

  async getHotelDevices(): Promise<ApiResult<SeamDevice[]>> {
    return this.handleRequest<SeamDevice[]>(
      this.client.get(`${this.basePath}/hotel-devices`),
    );
  }

  async mapDeviceToRoom(
    roomId: string,
    data: MapDeviceToRoomRequest,
  ): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.post(`${this.basePath}/rooms/${roomId}/map-device`, data),
    );
  }

  async unmapDeviceFromRoom(roomId: string): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.delete(`${this.basePath}/rooms/${roomId}/unmap-device`),
    );
  }

  async getDeviceCapabilities(
    deviceId: string,
  ): Promise<ApiResult<SeamDeviceCapabilities>> {
    return this.handleRequest<SeamDeviceCapabilities>(
      this.client.get(`${this.basePath}/devices/${deviceId}/capabilities`),
    );
  }
}
